export default "__VITE_ASSET__be3a37b1__"